import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=3b7edbab&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=3b7edbab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7edbab",
  null
  
)

export default component.exports